export default __webpack_public_path__ + "static/media/pcPicker.00aa9d9c.png";